import jwt_decode from 'jwt-decode';

export const checkTokenExpirationMiddleware = store => next => action => {
  const { token } = sessionStorage.getItem('token')
    ? sessionStorage.getItem('token')
    : store.getState().auth;

  if (token) {
    const decoded = jwt_decode(token);
    if (decoded.exp < Date.now() / 1000) {
      next({ type: 'LOGOUT', payload: '' });
    }
  }
  return next(action);
};
